import { defineStore } from "pinia";
import http from "@/http";
import { LIST_PRODUTO, ADD_PRODUTO, UPDATE_PRODUTO, DEL_PRODUTO } from "@/http/url";

export const useProdutoStore = defineStore("ProdutoStore", {
  state: () => {
    return {
      produtos: [],
      loaded: false,
    };
  },
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_PRODUTOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_PRODUTO)
          .then((response) => {
            this.produtos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_PRODUTO(produto) {
      return http
        .post(ADD_PRODUTO, produto)
        .then((response) => this.produtos.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_PRODUTO(produto) {
      return http.put(`${UPDATE_PRODUTO + produto.id}`, produto);
    },

    REMOVER_PRODUTO(id) {
      return http
        .delete(`${DEL_PRODUTO + id}`)
        .then(() => (this.produtos = this.produtos.filter((prod) => prod.id != id)));
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getProdutos() {
      return this.produtos;
    },

    getProdutoLoad(state) {
      return state.loaded;
    },

    getFilterProdutos: (state) => {
      return (filtro) =>
        state.produtos.filter(
          (p) =>
            !filtro || (p.codigo.includes(filtro.codigo) && p.descricao.includes(filtro.descricao))
        );
    },
  },
});
